import React, { useState, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { DeleteOutlined, HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import {
  getSpecificGardenFertilizerDictionaryRequest,
  removeSpecificGardenDictionaryRequest,
  updateGardenFertilizerDictionaryRequest,
} from '../requests/fertilizersGardenRequests';

const GardenFertilizersDictionaryEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [dictionaries, setDictionaries] = useState<any[]>([]);
  const [productName, setProductName] = useState('');

  useEffect(() => {
    toggleLoading(true);

    getSpecificGardenFertilizerDictionaryRequest(id)
      .then((response) => {
        if (response) {
          const { data, product } = response;
          toggleLoading(false);
          setDictionaries(data);
          setProductName(product?.name);
          setFields([
            {
              name: ['id'],
              value: id,
            },
          ]);
          data.map((dictionary: any) => {
            setFields((prevFields) => [
              ...prevFields,
              {
                name: ['dictionary-' + dictionary.dictionaryId],
                value: dictionary.dictionaryValue,
              },
            ]);
          });
        } else {
          history.push('/garden/fertilizers-dictionary');
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const addNewDictionary = () => {
    setDictionaries([
      ...dictionaries,
      { dictionaryId: `${dictionaries.length}N`, value: '' },
    ]);
  };

  const deleteDictionary = (id: number) => {
    const removeDictionary = dictionaries.filter(
      (dictionary) => dictionary.dictionaryId !== id
    );

    removeSpecificGardenDictionaryRequest(id).then(() => {
      setDictionaries(removeDictionary);
    });
  };

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    updateGardenFertilizerDictionaryRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const listDictionaries =
    dictionaries && dictionaries.length
      ? dictionaries.map((dictionary) => {
          return (
            <div
              key={`dictionary-${dictionary.dictionaryId}`}
              style={{ display: 'flex', width: '100%', alignItems: 'center' }}
            >
              <Form.Item
                name={`dictionary-${dictionary.dictionaryId}`}
                style={{ width: '50%', marginRight: '20px' }}
              >
                <Input />
              </Form.Item>
              <Button
                type="primary"
                icon={<DeleteOutlined />}
                onClick={() => deleteDictionary(dictionary.dictionaryId)}
                style={{ marginBottom: 24 }}
              >
                Usuń
              </Button>
            </div>
          );
        })
      : null;

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Nawozy</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/garden/fertilizers-dictionary">Słowniki</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/garden/fertilizers-dictionary/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <h3>Słowniki dla {productName}</h3>
              <br />
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>

              {listDictionaries}

              <Button onClick={addNewDictionary}>Dodaj kolejne słowo</Button>
              <br />
              <br />

              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/garden/fertilizers-dictionary">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/garden/fertilizers-dictionary">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default GardenFertilizersDictionaryEdit;
